import KnowledgeCheck from '@/components/knowledge-check'


export default function KnowledgeCheckPage() {

  return (
      <KnowledgeCheck/>
 
  )
} 